<template>
  <v-expansion-panel expand>
    <v-expansion-panel-content v-for="assessment in studentAssessments" :key="assessment.id"
                               :value="assessment.isOpen" v-on:input="setAssessmentsState(assessment.id)">
      <div slot="header" class="prevent-overflow break-module">
        <student-assessments-header :assessment="assessment"
                                    :open="assessment.isOpen"/>
      </div>
      <student-assessments-body :assessment="assessment"
                                :open="assessment.isOpen"
                                :reset="assessment.reset"/>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import StudentAssessmentsHeader from './StudentAssessmentsHeader'
  import { SET_STUDENT_ASSESSMENTS_SHOW_STATE } from '../../store/mutation-types'
  import StudentAssessmentsBody from './StudentAssessmentsBody'
  import { mapState } from 'vuex'

  export default {
    components: {
      StudentAssessmentsBody,
      StudentAssessmentsHeader
    },
    name: 'student-assessments-row',
    props: [],
    mixins: [],
    data () {
      return {}
    },
    methods: {
      setAssessmentsState (value) {
        this.$store.commit(SET_STUDENT_ASSESSMENTS_SHOW_STATE, value)
      }
    },
    computed: {
      ...mapState({
        studentAssessments: state => state.assessments.studentAssessments
      })
    },
    watch: {}
  }
</script>

<style scoped>
.break-module {
  word-break: initial;
  word-wrap: break-word;

  /* Word wrapping on long words not working on firefox correctly when using flex. */
  min-width: 0;

}
</style>



// WEBPACK FOOTER //
// src/components/student/StudentAssessmentsRow.vue